export class RemoveCouponAction {
  static type = '[BASKET] Remove coupon';
}
